var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7072 12.7069C15.8947 12.5193 16 12.265 16 11.9999C16 11.7347 15.8947 11.4804 15.7072 11.2929L10.0502 5.63585C9.95797 5.54034 9.84762 5.46416 9.72562 5.41175C9.60361 5.35934 9.47239 5.33176 9.33961 5.3306C9.20684 5.32945 9.07516 5.35475 8.95226 5.40503C8.82936 5.45531 8.71771 5.52957 8.62382 5.62346C8.52993 5.71735 8.45567 5.829 8.40539 5.9519C8.35511 6.0748 8.32981 6.20648 8.33096 6.33926C8.33212 6.47204 8.3597 6.60325 8.41211 6.72526C8.46452 6.84726 8.5407 6.95761 8.63621 7.04985L13.5862 11.9999L8.63621 16.9499C8.45406 17.1385 8.35326 17.3911 8.35554 17.6533C8.35782 17.9155 8.46299 18.1663 8.64839 18.3517C8.8338 18.5371 9.08462 18.6423 9.34681 18.6445C9.60901 18.6468 9.86161 18.546 10.0502 18.3639L15.7072 12.7069Z",
    fill: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.ca34fd04f347a22d7419374b0940df03.svg";
export { ForwardRef as ReactComponent };